<template>
  <tr>
    <td
      class="boss-center boss-table-4-link-cell"
      data-test="date"
    >
      {{ applicationDate }}
      <div data-test="time">
        {{ applicationTime }}
      </div>
    </td>
    <td class="boss-center">
      <span data-test="user-id">ID:{{ entry.userId }}</span>
      <span v-if="entry.isDuplicatedEntries">
        <br>
        <span
          v-tooltip="{ content: '同一セミナーに複数回応募している場合に表示されます。'}"
          class="boss-status-label"
          data-test="duplicate"
        >重複応募
        </span>
      </span>
      <div data-test="member-name">
        {{ memberName }}
      </div>
    </td>
    <td
      class="is-boss-only-pc"
      data-test="seminar-id"
    >
      セミナーID:{{ entry.seminar.id }}
      <div data-test="seminar-name">
        {{ seminarName }}
      </div>
    </td>
    <message-icon-information
      :message="entry.message"
      :is-entry="false"
    />
    <td class="boss-center is-boss-only-pc">
      <span data-test="status">{{ statusName }}</span>
    </td>
    <td class="pega-remarks-label is-boss-only-pc">
      <span data-test="remarks">{{ entry.remarks }}</span>
    </td>
  </tr>
</template>

<script>
import dayjs from 'dayjs'
import _ from 'lodash'
import { mapGetters } from 'vuex'
import MessageIconInformation from '@/components/atoms/MessageIconInformation'

export default {
  components: {
    MessageIconInformation
  },
  props: {
    entry: {
      type: Object,
      required: true
    }
  },
  computed: {
    ...mapGetters({
      seminarStatuses: 'seminarStatuses'
    }),
    applicationDate () {
      return dayjs(_.get(this.entry, 'entryDate')).format('YY/MM/DD')
    },
    applicationTime () {
      return dayjs(_.get(this.entry, 'entryDate')).format('HH:mm')
    },
    memberName () {
      return this.entry.userLastName + this.entry.userFirstName
    },
    seminarName () {
      if (this.entry.seminar.name.length > 20) {
        return this.entry.seminar.name.match(/^.{0,20}/) + '...'
      } else {
        return this.entry.seminar.name
      }
    },
    statusName () {
      return _.get(_.find(this.seminarStatuses, { id: this.entry.statusId }), 'name', '−')
    }
  }
}
</script>
